import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectTaskService } from 'src/app/Services/projecttask.service';
import { Project, ProjectTask } from 'src/app/objects/Project';
import { MatDialog } from '@angular/material/dialog';
import { ProjectService } from 'src/app/Services/project.services';
import { ProjectTaskAddComponent } from '../project/project-task-add/project-task-add.component';


@Component({
  selector: 'app-mytasks',
  templateUrl: './mytasks.component.html',
  styleUrls: ['./mytasks.component.css']
})
export class MytasksComponent implements OnInit {

 

projectTasks: ProjectTask[] = []; // Initialize with your data
 
  ProjectTaskColumns: string[] = ['title', 'description',  'dueDate', 'assignedTo','completed','edit'];
 
  
  ProjectId: number | any ;  
  project: Project |any;

  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 
  isMobile= false; 
    
   dataSource!: MatTableDataSource<ProjectTask>;
   editedRow: ProjectTask | undefined;
  constructor( private route: ActivatedRoute,
    private router: Router,
    private projectTaskService: ProjectTaskService,    
    private projectService: ProjectService,  
    private dialog: MatDialog) {}

    ngOnInit(): void {
      
    this.checkisMobile();
      // this.route.paramMap.subscribe((params) => {
      //   this.ProjectId = parseInt(params.get('id') || '0', 10);
      //   if (this.ProjectId > 0) {
      //     this.loadProject(this.ProjectId);
      //   }
      // }); 
       this.loadMyTasks();
     
    }
  

    loadMyTasks() {
    this.projectTaskService.getProjectTasks().subscribe((projectTasks) => {
      this.projectTasks = projectTasks; 
   //   this.projectTasks = projectTasks.filter(a=> a.dueDate >= Date(-7));
 
      this.dataSource = new MatTableDataSource<ProjectTask>(this.projectTasks );
     
    });
  }

  removeTaskfromProject(task:ProjectTask)
  {
    this.projectTaskService.deleteProjectTask(task)
    .subscribe(res => {
       
        
        this.isLoadingResults = true;
        console.log('Project edited successfully!');
       
         
       this.loadProject(this.project?.id);
       
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });  
  }

  editRow(element: ProjectTask) {
   
    this.editedRow = element; // {element };
  }

  cancelEdit(element: ProjectTask) {
    // Restore original values
    this.editedRow = undefined;
  }

  editProject(projectTask: ProjectTask) {
    // Implement the edit functionality here
    
    this.router.navigate(['ProjectTasks/edit/', projectTask.id]);
    // You can open a dialog or navigate to a separate edit page with the material's data
    console.log('Editing project:', projectTask);
  }
 
    openProjectTaskAdd(): void {
      let dialogRef = this.dialog.open(ProjectTaskAddComponent, {
        
        data: { projectId: this.project.id }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        //Load Project
       
        this.loadProject(this.ProjectId);
      });
    }
  
    loadProject(projectId: number) {
  
      this.projectService.getProject(projectId).subscribe((project) => {
        this.project = project;
        this.projectTasks = project.projectTasks;
        this.dataSource = new MatTableDataSource<ProjectTask>(project.projectTasks);
        console.log(this.dataSource)
          console.log(this.project.projectTasks); 
          
      });
   
    }
  
    checkisMobile() { 
     
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
   
      if(width < 768)
      {this.isMobile = true;
      }
        else
      {this.isMobile = false;}
      
      
    }
  

    saveEdit(element: ProjectTask) {
      // Update data source with edited values
      let projectTasks: ProjectTask[]= this.project.projectTasks!;
      let m:ProjectTask | any
      m = projectTasks.find(a=> a.id = element.id);
      m.title = element.title;
      m.description = element.description;
      m.dueDate = element.dueDate;
      m.assignedTo = element.assignedTo;
      m.completed = element.completed;
      if (m !== undefined) {
        this.projectTaskService.updateProjectTask(m)
      .subscribe(res => {
         
          
          this.isLoadingResults = false;
          console.log('Project edited successfully!');
          this.loadProject(this.project?.id);
        }, (err) => {
          console.log(err);
          this.isLoadingResults = false;
        });
      } 
      this.editedRow = undefined;
    }
  }